import { useTranslation } from "react-i18next";
import TextInput from "../../../../../components/forms/textInput";
import TextArea from "../../../../../components/forms/textarea";
import { IOrganizations } from "../../../../../setup/types/Organisation";
import styles from "./style.module.scss";

interface BasicInformationProps {
  organization?: IOrganizations;
}

const BasicInformation = ({ organization }: BasicInformationProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h3 className={styles.title}>{t("lbl_basic_info_title")}</h3>
        <p className={styles.subtitle}>{t("lbl_basic_info_description")}</p>
      </div>

      <div className={styles.inputContainer}>
        <TextInput
          disabled
          value={organization?.name}
          label={t("lbl_edit_profile_name")}
          containerWidth="100%"
        />
      </div>

      <TextArea
        value={organization?.description}
        disabled
        minInputHeight="100px"
        label={t("lbl_description_placeholder")}
        handleChange={() => console.log("test")}
      />
    </div>
  );
};

export default BasicInformation;
